import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { DataService } from '../../Services/data.service';


import { MatButtonModule } from '@angular/material/button';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';


@Component({
  selector: 'app-task-assigned',
  standalone: true,
  templateUrl: './task-assigned.component.html',
  styleUrls: ['./task-assigned.component.css'], 
  imports: [
    CommonModule,
    MatTableModule,
    MatCardModule,
    MatSortModule,
    MatPaginatorModule,
     MatButtonModule, FormsModule,
   MatIconModule, MatOptionModule, MatFormFieldModule,MatMenuTrigger,MatMenu
]
})
export class TaskAssignedComponent implements AfterViewInit {

 
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.getUnassignedTasks(); 
  }



  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.getUnassignedTasks(); 
  }
  
  
  editingRow: any = null;
backupRow: any = null;


users: any = [];
editingCell: { [key: string]: string } = {};
displayedColumns: string[] = [
  
  
  
  'taskId','refNum','status','assignTo','crtBy','crtTm'
];





editOrder(row: any): void {
  if (this.editingRow) {
    return;
  }
  this.backupRow = { ...row };
  this.editingRow = row;
}


startEdit(rowId: number, column: string) {
  this.editingCell[rowId] = column;
}



pendingSelection: { taskId: any, userName: string } | null = null;

  prepareSelection(order: any, userName: string) {
    
    this.pendingSelection = { taskId: order.taskId, userName: userName };
  }

 

  clearSelection() {
    this.pendingSelection = null;
  }
  onUserSelected(order: any, newUserName: string) {
    
    const isConfirmed = window.confirm(`Assign task ${order.taskId} to ${newUserName}?`);
    
    if (isConfirmed) {
      this.saveCell(order, 'assignTo', newUserName);
    }
  }

 
selectedTempUser: string = '';



cancelInstantEdit(taskId: string) {
  this.editingCell[taskId] = '';
  this.selectedTempUser = '';
}


saveCell(order: any, column: string, newValue: string) {
  order.assignTo = newValue;
  this.saveOrder(order, newValue);
}

startInstantEdit(taskId: string, userName: string) {
  
  this.users = []; 
  this.getUserListtoAssign(taskId);
  this.selectedTempUser = userName;
  this.editingCell[taskId] = 'assignTo'; 
}

getUserListtoAssign(taskId: any) {
  
  this.users = [];
  
  this.dataService.updateProgressBarSubject(true);

  
  this.dataService.getDataAsList('/common/notifications/' + taskId + '/reassign').subscribe({
    next: (response) => {
      this.users = response || []; 
      this.dataService.updateProgressBarSubject(false);
    },
    error: (err) => {
      this.dataService.updateProgressBarSubject(false);
    }
  });
}

selectedUserObj: any = null;
saveOrder(order: any, userId: any): void {
  this.dataService.updateProgressBarSubject(true);

  this.dataService.postDataForeditUser('/tasks/update-user-for-reassign', order).subscribe({  
    next: (response) => {
       
    
      const index = this.dataSource.data.findIndex(item => item.taskId === order.taskId);

      if (index !== -1) {
        
        this.dataSource.data[index].status = 'In Progress'; 
        this.dataSource.data[index].user = this.selectedTempUser;

      
        this.dataSource.data = [...this.dataSource.data];
      }

      this.dataService.updateProgressBarSubject(false);
      this.cancelInstantEdit(order.taskId);
    },
    error: (err) => {
      this.dataService.updateProgressBarSubject(false);
    }
  });
}

getUnassignedTasks() {
    this.dataService.updateProgressBarSubject(true);

    this.dataService.getDataAsList('/tasks/notification-list').subscribe({
      next: (response) => {

       
        this.dataSource.data = response || [];

        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dataService.updateProgressBarSubject(false);
      }
    });
  }
  onPageChange() {
  const tableElement = document.querySelector('.orders-container');
  if (tableElement) {
    // Ye table ke top ko screen ke top se align karega
    tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
}
